import type { MockGoalTicket } from '../types/describe.types';

const KEYWORD_TO_TICKET: Array<{
  keyword: string;
  ticket: MockGoalTicket;
}> = [
  {
    keyword: 'payment',
    ticket: {
      key: 'ENG-4022',
      title: 'Migrate Core Payment Service to AWS',
      status: 'Done',
    },
  },
  {
    keyword: 'onboarding',
    ticket: {
      key: 'PROD-2108',
      title: 'Redesign onboarding funnel for activation lift',
      status: 'In Progress',
    },
  },
  {
    keyword: 'search',
    ticket: {
      key: 'ENG-3711',
      title: 'Replace legacy search index with OpenSearch',
      status: 'Done',
    },
  },
  {
    keyword: 'launch',
    ticket: {
      key: 'GTM-512',
      title: 'Launch Q4 pricing experiment to enterprise',
      status: 'Done',
    },
  },
  {
    keyword: 'migrate',
    ticket: {
      key: 'ENG-4022',
      title: 'Migrate Core Payment Service to AWS',
      status: 'Done',
    },
  },
];

export function findGoalMatch(input: string): MockGoalTicket | null {
  const normalized = input.trim().toLowerCase();
  if (normalized.length < 3) return null;

  const match = KEYWORD_TO_TICKET.find(({ keyword }) =>
    normalized.includes(keyword)
  );
  return match ? match.ticket : null;
}
